export const checkStatus = (res, section) => {
    // console.log(res, section);
    if ([2, 3].includes(res.is_approved))
        return "new"
    else if (res[section] && res.is_approved == 0 || res.is_approved == 1)
        return "filled"
    else
        return "new"
}